import React, { useContext } from 'react';
import './styles.css';
import { LanguageContext } from '../../libs/Context';
const NewCopyrightFooter = () =>
{
	const { language } = useContext(LanguageContext);
	const path = window.location.pathname;

	return (
		<div className='flexRow alignCntr pdngMD hideScrollX footMinWidth' style={{ height: '10%' }}>
			{/* // <div
		// 	className={`flexRow alignCntr whiteBg ${
		// 		path === '/contacts' ? 'contactFooter' : 'newFooter'
		// 	}  hideScrollX`}
		// > */}
			<div className='flexAutoRow footerLogo alignCntr pointer pdngRSM'>
				<img
					src='/images/logos/In_logo.svg'
					alt='inLynk-logo'
					height={'116px'}
					width={'300px'}
				/>
			</div>
			<div className='flexMinWidthCol'>
				<span className='powerBytxt'>Powered by InLynk</span>
				<small className='subHeadingXXS lightTxt'>
					&copy; {new Date().getFullYear()}&nbsp;{language?.copyRightIVC}
				</small>
			</div>
			<div className='flexAutoRow primaryTxt termsofUse'>
				<div className='flexInline pdngHXXS breadCrumbTxt' onClick={() => window.open('https://www.instavc.com/terms-and-conditions/')}>Terms of use |</div>
				<div className='flexInline pdngHXXS breadCrumbTxt' onClick={() => window.open('https://www.inlynk.com/privacy-policy/')}> Privacy </div>
				{/* <div className='flexInline pdngHXXS breadCrumbTxt'> Disclaimer</div> */}
			</div>
		</div>
	);
};

export default NewCopyrightFooter;
